import { getUpgradeLinkProps } from '@anm/helpers/upgradeLink';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { landingsActions, landingsSelectors } from '../../../../../../store/modules/landings';
import { userSelectors } from '../../../../../../store/modules/user';
import { CheckboxValue } from '../../../../CustomizationForm/CustomizationFormCheckbox';

export const useWaveFooterCheckbox = () => {
  const dispatch = useDispatch();
  const landing = useSelector(landingsSelectors.selectLanding);
  const settings = useSelector(userSelectors.selectUserLandingsSettings);

  const isCheckboxDisabled = !settings?.canRemoveFooter;
  const isDefaultChecked = landing?.parameters?.hasFooter;

  const handleChange = useCallback(
    ({ value }: CheckboxValue) => {
      dispatch(
        landingsActions.updateLanding({
          ...landing,
          parameters: {
            ...landing?.parameters,
            hasFooter: value
          }
        })
      );
    },
    [landing]
  );

  const renderTooltip = isCheckboxDisabled
    ? () => (
        <>
          To remove Footer, please <a {...getUpgradeLinkProps()}>upgrade</a>
        </>
      )
    : undefined;

  return [isCheckboxDisabled, !!isDefaultChecked, renderTooltip, handleChange] as const;
};
